import React from "react";
import { useTranslation } from "react-i18next";
import "./MaintenancePage.sass";

export const MaintenancePage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="maintenance-page">
      <div className="maintenance-page__content">
        <h1 className="maintenance-page__title">{t("maintenance.title")}</h1>
        <p className="maintenance-page__text">{t("maintenance.message")}</p>
        <p className="maintenance-page__text">{t("maintenance.eta")}</p>
        <p className="maintenance-page__text">{t("maintenance.contact")}</p>
        <a
          className="maintenance-page__email"
          href={`mailto:${t("maintenance.email")}`}
        >
          {t("maintenance.email")}
        </a>
        <p className="maintenance-page__text">{t("maintenance.thanks")}</p>
      </div>
    </div>
  );
};
